import React from "react";
import { Link } from "react-router-dom";
import { ChevronRight } from "lucide-react";
import { cn } from "../../../lib/utils";

export const SectionHeader: React.FC<{
  title: string;
  subtitle?: string;
  actionLabel?: string;
  actionHref?: string;
}> = ({ title, subtitle, actionLabel = "See all", actionHref }) => (
  <div className="mb-3 flex items-end justify-between gap-3 px-1">
    <div className="min-w-0">
      <h2 className="text-base font-bold font-jakarta text-gray-900">{title}</h2>
      {subtitle && <p className="text-xs text-gray-500 mt-0.5">{subtitle}</p>}
    </div>
    {actionHref && (
      <Link
        to={actionHref}
        className="flex shrink-0 items-center text-xs font-semibold text-primary-600 active:opacity-60"
      >
        {actionLabel}
        <ChevronRight className="h-3.5 w-3.5" />
      </Link>
    )}
  </div>
);

export const MobileCard: React.FC<{ className?: string; children: React.ReactNode }> = ({
  className,
  children,
}) => (
  <div className={cn("rounded-3xl border border-gray-100 bg-white p-4 shadow-[0_1px_2px_rgba(13,14,19,0.04)]", className)}>
    {children}
  </div>
);
